type ResendState = { status: string; paidAt: string | null; expiresAt: string; resendOrderId: string | null };

export function describeResendPayment(request: ResendState, now = Date.now()) {
  if (request.paidAt || request.status === 'PAID' || request.status === 'COMPLETED') {
    return { label: 'Opłacono ponowną wysyłkę', color: 'text-success',
      description: request.resendOrderId ? 'Utworzono osobne zamówienie do obsługi wysyłki.' : 'Wpłata potwierdzona. Zamówienie ponownej wysyłki nie zostało jeszcze powiązane.' };
  }
  if (request.status === 'PAYMENT_STARTED') {
    return { label: 'Oczekiwanie na potwierdzenie płatności', color: 'text-warning',
      description: 'Klient rozpoczął płatność w Przelewy24. EcomFlow nie ma jeszcze potwierdzenia wpłaty.' };
  }
  const expired = request.status === 'EXPIRED' || (request.status === 'PENDING' && new Date(request.expiresAt).getTime() <= now);
  return { label: 'Brak potwierdzenia wpłaty', color: 'text-warning', description:
    expired ? 'Link do płatności wygasł. Jeśli klient zapłacił, płatność wymaga sprawdzenia w Przelewy24.'
      : request.status === 'INVALIDATED' ? 'Link do płatności został unieważniony.'
      : request.status === 'FAILED' ? 'Wystąpił problem z obsługą płatności. Sprawdź transakcję w Przelewy24.'
      : 'Utworzono link do płatności. Samo zgłoszenie ponownej wysyłki nie potwierdza zapłaty.' };
}

export function formatResendHistory(entry: { action: string; description?: string }) {
  switch (entry.action) {
    case 'resend_requested':
      return { title: 'Zgłoszono ponowną wysyłkę', description: 'Utworzono link do opłacenia ponownej wysyłki. Ten wpis nie oznacza potwierdzenia wpłaty.', color: 'text-warning', icon: '↩' };
    case 'resend_payment_confirmed':
      return { title: 'Opłacono ponowną wysyłkę', description: entry.description || 'Przelewy24 potwierdziły płatność za ponowną wysyłkę.', color: 'text-success', icon: '✓' };
    case 'resend_order_created':
      return { title: 'Utworzono zamówienie ponownej wysyłki', description: entry.description || 'Powiązane zamówienie jest dostępne w sekcji Ponowna wysyłka.', color: 'text-accent-primary', icon: '↩' };
    default: return null;
  }
}
